<div style="width: 100%; ">
  <mat-card class="box">
      <div class="divtitle">
        <span class="flex-container" style="padding: 8px;">
          <h1 class="label">{{"companies.label" | transloco}}</h1>
          <button mat-raised-button color="primary" routerLink="/company" >{{ 'companies.new' | transloco}}</button>
        </span>
      </div>
  </mat-card>
</div>

<div style="width: 100%;">
  <mat-card class="box">
    <div>
      <div class="formBox">
        <form method="post" class="wrapper" >
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="id">
            <!-- ID Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > ID. </th>
              <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <!-- Logo Column -->
            <ng-container matColumnDef="logo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.logo" | transloco}}</th>
              <mat-cell *matCellDef="let element">
                <ng-container *ngIf='element.has_logo=="1"'>
                  <img src="https://j4ntdxomj2.execute-api.eu-central-1.amazonaws.com/companies/{{element.id}}/logo" class="logo">
                </ng-container>
              </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.company" | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <!-- Direccion Column -->
            <ng-container matColumnDef="address_line_1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.address" | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.address_line_1}} </td>
            </ng-container>

            <!-- Direccion Column -->
            <ng-container matColumnDef="address_line_2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >  </th>
              <td mat-cell *matCellDef="let element"> {{element.address_line_2}} </td>
            </ng-container>

            <!-- Ciudad Column -->
            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.city" | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.city}} </td>
            </ng-container>

            <!-- País Column -->
            <ng-container matColumnDef="country">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.country" | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.country}} </td>
            </ng-container>

            <!-- Contacto Nombre Column -->
            <ng-container matColumnDef="first_contact_person_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.contact" | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.first_contact_person_name}} </td>
            </ng-container>

            <!-- Contacto Email Column -->
            <ng-container matColumnDef="first_contact_person_email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.email" | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.first_contact_person_email}} </td>
            </ng-container>

            <!-- Contacto Telefono Column -->
            <ng-container matColumnDef="first_contact_person_phone">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.phone" | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.first_contact_person_phone}} </td>
            </ng-container>

            <!-- Contacto Emergencias Nombre Column -->
            <ng-container matColumnDef="emergency_contact_person_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.emergencies" | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.emergency_contact_person_name}} </td>
            </ng-container>

            <!-- Contacto Emergencias Email Column -->
            <ng-container matColumnDef="emergency_contact_person_email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{"companies.email" | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.emergency_contact_person_email}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns; let j =index;"
            (click)="onRowClicked(row); $event.stopPropagation()" tabindex="0" (keydown.enter)="onRowClicked(row)"
            [ngClass]="{'row1':j%2 === 0 , 'row2':j%2 != 0 }"> </tr>

          </table>
          <div class="divPag">
            <mat-paginator [pageSizeOptions]="[9, 10, 20, 50]"
                            showFirstLastButtons
                            aria-label="Select page">
            </mat-paginator>
          </div>
        </form>
      </div>
  </div>
  </mat-card>
</div>

<div>
  <mat-card *ngIf="isLoading" class="center-loading">
    <mat-card-content style="margin: 20%;" >
      <mat-progress-spinner style="margin: 0 auto;" color="primary" mode='indeterminate'value='50'></mat-progress-spinner>
    </mat-card-content>
  </mat-card>
</div>
